import { useEffect, useRef, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";

const FRASES = [
  "Analizando partidas del presupuesto",
  "Generando escena 3D del proyecto",
  "Renderizando materiales y acabados",
  "Sincronizando luces y sombras",
  "Compilando frames del clip",
];

const VIDEO_SRC = "/video/LTX_2.3_t2v_00008.mp4";
const DURACION_GEN_MS = 5000;

export default function AIVideoPreview({ trigger }) {
  const [generando, setGenerando] = useState(true);
  const [progreso, setProgreso] = useState(0);
  const [fraseIdx, setFraseIdx] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    setGenerando(true);
    setProgreso(0);
    setFraseIdx(0);
    const inicio = Date.now();
    const interval = setInterval(() => {
      const t = Date.now() - inicio;
      const p = Math.min(100, (t / DURACION_GEN_MS) * 100);
      setProgreso(p);
      setFraseIdx(Math.min(FRASES.length - 1, Math.floor((p / 100) * FRASES.length)));
      if (p >= 100) {
        clearInterval(interval);
        setGenerando(false);
      }
    }, 120);
    return () => clearInterval(interval);
  }, [trigger]);

  useEffect(() => {
    if (!generando && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [generando]);

  return (
    <div className="rx-card overflow-hidden border border-slate-200">
      <div className="px-4 pt-3 pb-2 flex items-center justify-between border-b border-slate-100">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-gradient-to-br from-blue-500 to-purple-500 text-white">
            <Sparkles className="w-3.5 h-3.5" />
          </span>
          <span className="font-display font-bold text-sm text-slate-800">
            Vídeo del proyecto · IA
          </span>
        </div>
        {generando && (
          <span className="text-[11px] uppercase tracking-widest font-bold text-blue-600 tabular-nums">
            {Math.round(progreso)}%
          </span>
        )}
      </div>

      <div className="relative aspect-video bg-slate-900">
        {generando ? (
          <div
            className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-white"
            data-testid="ai-video-generating"
          >
            <div
              className="absolute inset-0 opacity-60"
              style={{
                background:
                  "radial-gradient(ellipse at center, rgba(59,130,246,0.35) 0%, rgba(15,23,42,0) 70%)",
              }}
            />
            <div className="absolute inset-0 ai-video-shimmer" />
            <div className="relative flex flex-col items-center gap-2">
              <Loader2 className="w-7 h-7 animate-spin text-blue-300" />
              <div className="text-xs uppercase tracking-widest font-bold text-blue-200">
                Generando vídeo…
              </div>
              <div className="text-[11px] text-slate-300 max-w-[80%] text-center">
                {FRASES[fraseIdx]}…
              </div>
            </div>
          </div>
        ) : (
          <video
            ref={videoRef}
            src={VIDEO_SRC}
            className="absolute inset-0 w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            data-testid="ai-video-player"
          />
        )}
      </div>

      <div className="h-1 w-full bg-slate-200">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-purple-500 transition-[width] duration-150"
          style={{ width: `${generando ? progreso : 100}%` }}
        />
      </div>
    </div>
  );
}
